export default __webpack_public_path__ + "static/media/minus_white.680b3901.svg";